import { createSelector } from '@reduxjs/toolkit';

import { diagramSnapshotSelector } from 'src/selectors/diagramSnapshot';
import { memoizeSelectorFactory } from 'src/selectors/memoizeSelectorFactory';

export const projectNodeDataArraySelector = memoizeSelectorFactory(
  (projectId: string) =>
    createSelector(
      diagramSnapshotSelector(projectId),
      (diagram) => diagram?.model?.nodeDataArray || []
    )
);

export const prevProjectNodeDataArraySelector = memoizeSelectorFactory(
  (projectId: string) =>
    createSelector(
      diagramSnapshotSelector(projectId),
      (diagram) => diagram?.model?.modelData.draftData?.prevNodeDataArray || []
    )
);
